import { useState } from "react";
import { implementationInstruction } from "../../utils/implementationInstruction";

async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.left = "-9999px";
  document.body.appendChild(area);
  area.select();
  document.execCommand("copy");
  document.body.removeChild(area);
}

export function CopyInstructionButton({ action, site, className }) {
  const [copied, setCopied] = useState(false);

  const onClick = async (event) => {
    event.stopPropagation();
    try {
      await copyText(implementationInstruction(action, site));
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      title="Copy as an instruction for an AI"
      className={className}
    >
      {copied ? "Copied" : "Copy for AI"}
    </button>
  );
}
